<div *ngIf="horizontalMenu" class="navbar-header d-xl-block d-none">
  <!-- Navbar brand -->
  <ul class="nav navbar-nav flex-row">
    <li class="nav-item">
      <a class="navbar-brand" [routerLink]="['/']">
        <span class="brand-logo">
          <img src="{{ coreConfig.app.appLogoImage }}" alt="brand-logo" width="36" />
        </span>
        <h2 class="brand-text mb-0">{{ coreConfig.app.appName }}</h2>
      </a>
    </li>
  </ul>
  <!--/ Navbar brand -->
</div>
<div class="navbar-container navbar-container--branded d-flex content justify-content-between align-items-center w-100">
  <div class="navbar-left d-flex align-items-center min-width-0">
    <!-- Menu Toggler -->
    <ul class="nav navbar-nav d-xl-none flex-shrink-0" *ngIf="!coreConfig.layout.menu.hidden">
      <li class="nav-item">
        <a class="nav-link menu-toggle" (click)="toggleSidebar('menu')">
          <span [data-feather]="'menu'" [class]="'ficon'"></span>
        </a>
      </li>
    </ul>

    <app-school-switcher *ngIf="schoolName"></app-school-switcher>

    <h4 class="zl-black mb-0 ml-2 text-nowrap font-medium-2 page-title"
        *ngIf="!schoolName && pageTitle">
      {{ pageTitle }}
    </h4>

    <!-- Secondary toolbar (topic access, promos, timer) -->
    <div class="navbar-left__extras d-none d-lg-flex align-items-center" *ngIf="largeScreen">
      <ng-container *ngIf="showContentForm && isStudent">
        <app-student-topic-access></app-student-topic-access>
      </ng-container>

      <div (click)="openUpgradeModal()" class="cursor-pointer mawingu-banner"
        *ngIf="!isSubscribedUser && isMawinguUser">
        <div>
          <h6 class="zl-black mb-0 ml-1 mr-1 text-nowrap font-medium-1">Claim my Discount</h6>
          <h6 class="text-success ml-1 mr-1 fw-semibold mb-0">Holiday plan <span class="ml-1">></span></h6>
        </div>
      </div>

      <div class="timer p-auto rounded" *ngIf="showTimer">
        <div class="d-flex align-items-center">
          <span class="countdown">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
              <path fill="#31ABE0"
                d="M10 3q-.425 0-.713-.288T9 2q0-.425.288-.713T10 1h4q.425 0 .713.288T15 2q0 .425-.288.713T14 3h-4Zm2 11q.425 0 .713-.288T13 13V9q0-.425-.288-.713T12 8q-.425 0-.713.288T11 9v4q0 .425.288.713T12 14Zm0 8q-1.85 0-3.488-.713T5.65 19.35q-1.225-1.225-1.938-2.863T3 13q0-1.85.713-3.488T5.65 6.65q1.225-1.225 2.863-1.938T12 4q1.55 0 2.975.5t2.675 1.45l.7-.7q.275-.275.7-.275t.7.275q.275.275.275.7t-.275.7l-.7.7Q20 8.6 20.5 10.025T21 13q0 1.85-.713 3.488T18.35 19.35q-1.225 1.225-2.863 1.938T12 22Zm0-2q2.9 0 4.95-2.05T19 13q0-2.9-2.05-4.95T12 6Q9.1 6 7.05 8.05T5 13q0 2.9 2.05 4.95T12 20Zm0-7Z" />
            </svg>
            {{ formatTime(countdownValue) }}
          </span>
        </div>
      </div>
    </div>
  </div>

  <div class="navbar-right d-flex align-items-center">
    <ul class="nav navbar-nav align-items-center navbar-right__nav">
    <li ngbDropdown class="nav-item navbar-lang">
      <a class="nav-link navbar-lang__toggle" ngbDropdownToggle id="navbarLangDropdown"
         href="javascript:void(0)">
        <span class="material-symbols-outlined navbar-lang__icon" aria-hidden="true">language</span>
        <span class="navbar-lang__label">{{ languageLabel }}</span>
      </a>
      <div ngbDropdownMenu aria-labelledby="navbarLangDropdown" class="dropdown-menu dropdown-menu-right">
        <a ngbDropdownItem *ngFor="let lang of languageOptions | keyvalue"
           href="javascript:void(0)"
           (click)="setLanguage(lang.key)">{{ lang.value.title }}</a>
      </div>
    </li>

    <li *ngIf="isStudent" class="nav-item navbar-right__gifts d-none d-md-flex align-items-center">
      <app-gifts></app-gifts>
    </li>

      <app-navbar-notification></app-navbar-notification>

      <!-- User Dropdown -->
      <li ngbDropdown class="nav-item dropdown-user navbar-user">
        <a class="nav-link dropdown-toggle dropdown-user-link navbar-user__toggle p-0"
           ngbDropdownToggle id="navbarUserDropdown"
           aria-haspopup="true" aria-expanded="false">
          <ng-container *ngIf="currentUser">
            <div class="navbar-user__info d-none d-sm-flex flex-column">
              <span class="navbar-user__name">{{ currentUser.name | titlecase }}</span>
              <span class="navbar-user__role">{{ userRoleLabel }}</span>
            </div>
            <span class="navbar-user__avatar" aria-hidden="true">
              {{ currentUser.name | initials | uppercase }}
            </span>
            <span class="material-symbols-outlined navbar-user__chevron" aria-hidden="true">expand_more</span>
          </ng-container>
        </a>
        <div ngbDropdownMenu aria-labelledby="navbarUserDropdown" class="dropdown-menu dropdown-menu-right">
          <a ngbDropdownItem [routerLink]="['/profile']"><span [data-feather]="'user'" [class]="'mr-50'"></span>
            Profile</a>
          <!--a ngbDropdownItem [routerLink]="['/account-settings/']"><span [data-feather]="'settings'" [class]="'mr-50'"></span> Settings</a-->
          <!--  
          <a ngbDropdownItem [routerLink]="['/']"><span [data-feather]="'check-square'" [class]="'mr-50'"></span> Task</a>
          <a ngbDropdownItem [routerLink]="['/']">
            <span [data-feather]="'message-square'" [class]="'mr-50'"></span> Chats
          </a>
        -->
          <div class="dropdown-divider"></div>
          <a ngbDropdownItem (click)="modalOpenVC(shareZl)">
            <span [data-feather]="'share-2'" [class]="'mr-50'"></span>
            Share
          </a>
          <div class="dropdown-divider"></div>
          <a ngbDropdownItem (click)="logout()">
            <span [data-feather]="'power'" [class]="'mr-50'"></span>
            Logout
          </a>
        </div>
      </li>
      <!--/ User Dropdown -->
    </ul>
  </div>
</div>

<!--Modal for upgrade-->
<ng-template id="upgradeModal" #upgradeModal let-modal>
  <div class="modal-header" id="payment-modal-header" style="background-color: #ffffff">
    <button type="button" class="close" (click)="cancelPaymentProcess()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body p-md-3 p-1 mb-1 mb-md-0" id="payment-modal-body"
    style="background-color: #ffffff; /*min-height: 48rem*/" tabindex="0" ngbAutofocus>
    <app-upgrade-page [planName]="planName" (cancelPaymentProcessEvt)="cancelPaymentProcess()"
      (processStageEvt)="processStage($event)"></app-upgrade-page>
  </div>
</ng-template>

<!-- share zl modal -->
<ng-template #shareZl let-modal>
  <div class="share">
    <button type="button" class="close btn close-button" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
    <div class="equal-columns">
      <div class="column">
        <div class="mx-2 my-2 text-center">
          <h2 class="zl-black pt-2 pb-2">Zeraki Learning Rocks!</h2>
          <img src="assets/images/elements/learning illustration.svg" alt="share" />
        </div>
      </div>
      <div class="column share-bg rounded-right">
        <div class="mx-2 my-2 text-white">
          <h2 class="text-white pt-2 pb-2">Share</h2>
          <p class="card-text-1 mb-2">
            Tell your friends, family and classmates to join Zeraki Learning.
          </p>
          <div class="input-group">
            <input type="text" class="form-control" [value]="currentUrl" readonly />
            <div class="input-group-append">
              <button type="button" class="btn btn-icon share-btn" (click)="shareUrl()" rippleEffect>
                <span [data-feather]="'copy'"></span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div></div>
    </div>
  </div>
</ng-template>